import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=48e6fe3e&scoped=true"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatus.vue?vue&type=style&index=0&id=48e6fe3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6fe3e",
  null
  
)

export default component.exports